import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

import { store } from '../stores/store'
import { useRunState } from './provider/useRunState'
import { useTrackController } from './models/track/useTrackController'

export const GameResetBridge = observer(function GameResetBridge() {
    const runState = useRunState()
    const trackController = useTrackController()
    const pending = store.gameResetPending

    useEffect(() => {
        if (!pending) {
            return
        }

        runState.reset({ resetGear: true })
        trackController.restartTrack()
        trackController.clearEndDeceleration()
        trackController.setSpeedMultiplier(1)
        trackController.setTrackPaused(false)
        store.clearGameResetPending()
    }, [pending, runState, trackController])

    return null
})
